import { ItemModel } from "lib/services/catalogical-models";
import { CatalogicalService } from "lib/services/catalogical-service";
import { useEffect, useState } from "react";

/**
 * Resolves an array of tool taxonomy IDs to their display names
 * by fetching from the Catalogical aiforme domain.
 */
export const useToolNames = (taxonomyIds: string[]): Record<string, string> => {
  const [toolNames, setToolNames] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!taxonomyIds.length) {
      setToolNames({});
      return;
    }
    let cancelled = false;

    const service = new CatalogicalService<ItemModel>("aiforme");
    service
      .getItems({
        filters: { taxonomyId: taxonomyIds },
        pageSize: taxonomyIds.length,
        sortBy: [],
        sortDirection: [],
      })
      .then((response) => {
        if (cancelled) return;
        if (response?.data) {
          const names: Record<string, string> = {};
          response.data.forEach((item) => {
            if (item.taxonomyId && item.title) {
              names[item.taxonomyId] = item.title;
            }
          });
          setToolNames(names);
        }
      })
      .catch(() => {
        if (cancelled) return;
        const fallback: Record<string, string> = {};
        taxonomyIds.forEach((id) => {
          const parts = id.split("/");
          fallback[id] = parts[parts.length - 1].replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
        });
        setToolNames(fallback);
      });

    return () => {
      cancelled = true;
    };
  }, [taxonomyIds.join(",")]);

  return toolNames;
};
